import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../App.css';
import '../dashBoardNew/dashboardNew.css';
import Sidebar from '../dashboard/Sidebar';
import Dashheader from '../Dash-header/Dashheader';
import { Link } from 'react-router-dom';
import { END_URL, IMG_URL } from '../../config';
import { format } from 'date-fns';
import round from '../../images/rounded-check-orange.svg';
import checkIcon from '../../images/tick-icon.svg';
import todoIcon from '../../images/todo-icon.svg';
// import UploadFileWidget, { fileTypeOptions } from '.e/UploadFileWidget';

import { useNavigate } from 'react-router-dom';

import UserFooter from '../footer/UserFooter.jsx';


import downloadIcon from '../../images/download-icon.svg'; // adjust path as needed


import UploadFileWidget, { fileTypeOptions } from '../evidence/UploadFileWidget.jsx';



function ConfirmationModal({ isOpen, onClose, onConfirm, message }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{message}</h3>
        <div className="modal-buttons">
          <button onClick={onClose} className="btn btn-secondary">Cancel</button>
          <button onClick={onConfirm} className="btn btn-primary">Confirm</button>
        </div>
      </div>
    </div>
  );
}



function DashboardNew() {
  const [expanded1, setExpanded] = useState(false);
  const [evidenceList, setEvidenceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [username, setUsername] = useState('User');

  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);
  const [notificationToDelete, setNotificationToDelete] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);


  const [notifications, setNotifications] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(true);

  const [additionalInfo, setAdditionalInfo] = useState(null);
  const [additionalInfoLoading, setAdditionalInfoLoading] = useState(true);
  const [dynamicContent, setDynamicContent] = useState(null);

  const [caseUpdates, setCaseUpdates] = useState([]);
  const [caseUpdatesLoading, setCaseUpdatesLoading] = useState(true);
  const [caseUpdatesError, setCaseUpdatesError] = useState(null);


  const navigate = useNavigate();





  const capitalizeFirstLetter = (string) => {
    if (!string) return 'User';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };



  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = sessionStorage.getItem('authToken');
        const userData = JSON.parse(sessionStorage.getItem('user'));

        // Set username from session storage
        if (userData?.name) {
          setUsername(userData.name);
        }

        // Fetch evidence
        const evidenceResponse = await axios.get(`${END_URL}evidenceindex`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setEvidenceList(evidenceResponse.data.evidence);

        // Fetch notifications
        const notificationsResponse = await axios.get(`${END_URL}notifications`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setNotifications(notificationsResponse.data.notification);

        // Fetch profile data
        const profileResponse = await axios.get(`${END_URL}profiles`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setProfile(profileResponse.data);

        const additionalInfoResponse = await axios.get(`${END_URL}personaldetail`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setAdditionalInfo(additionalInfoResponse.data.personaldetail);




      } catch (err) {
        console.error("Error fetching data:", err);
        setError('Failed to load data');
      } finally {
        setLoading(false);
        setNotificationsLoading(false);
        setProfileLoading(false);
        setAdditionalInfoLoading(false);
      }
    };

    fetchData();
  }, []);

const handleDownload = (evidence) => {
  window.open(`${IMG_URL}/file-image/${evidence.image}`);
};


  // const handleDownload = async (evidence) => {
  //   try {
  //     const token = sessionStorage.getItem('authToken');
  //     const response = await axios.get(`${END_URL}file/${evidence.image_name}`, {
  //       headers: { Authorization: `Bearer ${token}` },
  //       responseType: 'blob',  // fetch as binary blob
  //     });

  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', evidence.image_name);
  //     document.body.appendChild(link);
  //     link.click();

  //     // Clean up
  //     link.parentNode.removeChild(link);
  //     window.URL.revokeObjectURL(url);

  //   } catch (error) {
  //     console.error('Error downloading file:', error);
  //     alert('Failed to download file.');
  //   }
  // };



  useEffect(() => {
    const fetchCaseUpdates = async () => {
      try {
        const response = await axios.get(`${END_URL}caseupdate`);
        if (response.data.status) {
          const sortedUpdates = response.data.data.sort((a, b) => new Date(b.date) - new Date(a.date));
          setCaseUpdates(sortedUpdates.slice(0, 2)); // store only latest 2
        } else {
          setCaseUpdatesError('Failed to fetch case updates');
        }
      } catch (error) {
        setCaseUpdatesError(error.message || 'Something went wrong fetching case updates');
      } finally {
        setCaseUpdatesLoading(false);
      }
    };

    fetchCaseUpdates();
  }, []);


  useEffect(() => {
    const fetchDynamicContent = async () => {
      try {
        const response = await axios.get(`${END_URL}dynamic-page`);
        setDynamicContent(response.data.data); // Assuming your API returns { data: ... }
      } catch (error) {
        console.error('Failed to fetch dynamic content:', error);
      }
    };

    fetchDynamicContent();
  }, []);





  // Status display configuration
  const statusDisplay = {
    pending: <h4 className="status-pending">Pending</h4>,
    accepted: <h4 className="status-approved">Approved</h4>,
    rejected: <h4 className="status-rejected">Rejected</h4>
  };


  const personalDetailFields = [
    'name',
    'lastname',
    'email',
    'phone',
    'address',
    'city',
    'state',
    'postalcode',
    'country_id',
    'dob',
    'occupation'
  ];

  function getPersonalDetailsCompletion(profile) {
    if (!profile) return 0;
    let filled = 0;
    personalDetailFields.forEach(field => {
      const value = profile[field];
      if (value !== undefined && value !== null && value !== '') {
        filled += 1;
      }
    });
    return Math.round((filled / personalDetailFields.length) * 100);
  }



  const shoppingDetailFields = [
    'primary_shopper',
    'shopping_frequency',
    'average_spend',
    'sale_price_usage',
    'pricing_awareness',
    'supermarket_used',
    'household_people',
    'store_location',
    'preferred_contact',
    'heard_about',
    'consent'
  ];

  function getShoppingDetailsCompletion(profile) {
    if (!profile) return 0;
    let filled = 0;
    shoppingDetailFields.forEach(field => {
      const value = profile[field];
      if (Array.isArray(value)) {
        if (value.length > 0) filled += 1;
      } else if (value !== undefined && value !== null && value !== '') {
        filled += 1;
      }
    });
    return Math.round((filled / shoppingDetailFields.length) * 100);
  }








  const additionalInfoFields = [
    "representing",
    "currentMember",
    "willingToRegister",
    "awareOfPricingProblems",
    "consent"//,
    // "user_status"
  ];

  // function getAdditionalInfoCompletion(profile) {
  //   if (!profile) return 0;

  //   let filled = 0;
  //   let totalFields = additionalInfoFields.length;

  //   additionalInfoFields.forEach(field => {
  //     const value = profile[field];
  //     if (value !== undefined && value !== null && value !== '') {
  //       filled += 1;
  //     }
  //   });

  //   if (profile.representing === "Yes") {
  //     totalFields += 1;
  //     if (profile.dependents !== undefined && profile.dependents !== null && profile.dependents !== '') {
  //       filled += 1;
  //     }
  //   }

  //   return Math.round((filled / totalFields) * 100);
  // }


  const handleRemoveNotification = (id) => {
    setNotificationToDelete(id);
    setModalOpen(true);
  };




  const handleConfirmDelete = async () => {
    if (!notificationToDelete) return;
    const token = sessionStorage.getItem('authToken');
    if (!token) return;

    try {
      await axios.post(
        `${END_URL}notifications/${notificationToDelete}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNotifications(prev => prev.filter(notif => notif.id !== notificationToDelete));
      setModalOpen(false);
    } catch (error) {
      console.error('Error deleting notification:', error);
      setError('Failed to delete notification. Please try again.');
      setModalOpen(false);
    }
  };






  function getAdditionalInfoCompletion(profile) {
    if (!profile) return 0;
    let fields = [...additionalInfoFields];

    // Conditional fields
    if (profile.representing === 'yes') {
      fields.push('numRepresented', 'dependents');
    }
    if (profile.currentMember === 'coles' || profile.currentMember === 'woolworth') {
      fields.push('number');
    }
    if (profile.paymentMethods === 'other') {
      fields.push('otherText');
    }

    let filled = 0;
    fields.forEach(field => {
      const value = profile[field];
      if (value !== undefined && value !== null && value !== '') {
        filled += 1;
      }
    });
    return Math.round((filled / fields.length) * 100);
  }



  const personalDetailsCompleted = profile && getPersonalDetailsCompletion(profile) === 100;

  const personalCompletion = profile ? getPersonalDetailsCompletion(profile) : 0;
  const shoppingCompletion = profile ? getShoppingDetailsCompletion(profile) : 0;
  const additionalCompletion = additionalInfo ? getAdditionalInfoCompletion(additionalInfo) : 0;

  const overallCompletion = Math.round((personalCompletion + shoppingCompletion + additionalCompletion) / 3);




  return (
    <div className="dashboard-container full-width">
      <Dashheader />
      <div className="container">
        <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3">
            <div className="dashboard-side-div">
              <Sidebar />
              <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <main className="content">
              <div className="form-container">
                <div className="dashbord-first">
                  <h3>Welcome Back, {capitalizeFirstLetter(username)} 👋</h3>
                  <div dangerouslySetInnerHTML={{ __html: dynamicContent?.dashboardcontent1 }} />
                  <div className="chip-col">
                    <div className="chip" id='complete'>✅ EOI Submitted</div>
                    <div className="chip" id='inProgress'>📊 {overallCompletion}% Profile Complete</div>
                    <div className="chip" id='info'>
                      {profile?.user_status?.evidence
                        ? '✅ Evidence Uploaded'
                        : '📝 Next Step: Upload Evidence'
                      }
                    </div>
                  </div>

                </div>
                <div className="dashnew-wrapp">
                  <div className="row">
                    <div className="col-6 prg-col1">
                      <h3>Your Progress</h3>
                      <div className="prg-col11">
                        <div
                          className="prg-circ"
                          style={{
                            background: `conic-gradient(#125D38 ${overallCompletion}%, #e9efee 0)`
                          }}
                        >
                          <span className="prg-text">{overallCompletion}%</span>
                        </div>
                        <div className="prg-checklist">
                          <Link to="/users">
                            <button className="prg-btn1">
                              <span>
                                {personalCompletion === 100 ? (
                                  <img src={checkIcon} alt="Completed" />
                                ) : (
                                  <img src={todoIcon} alt="Incomplete" />
                                )}
                              </span>
                              Personal Details
                              {profile && (
                                <span style={{ marginLeft: 8, fontSize: 14, color: '#666' }}>
                                  {personalCompletion}%
                                </span>
                              )}
                            </button>
                          </Link>

                          <Link to="/users/2">
                            <button className="prg-btn1">
                              <span>
                                {shoppingCompletion === 100 ? (
                                  <img src={checkIcon} alt="Completed" />
                                ) : (
                                  <img src={todoIcon} alt="Incomplete" />
                                )}
                              </span>
                              Shopping Details
                              {profileLoading ? (
                                <span style={{ marginLeft: 8, fontSize: 14, color: '#999' }}>...</span>
                              ) : (
                                <span style={{ marginLeft: 8, fontSize: 14, color: '#666' }}>
                                  {shoppingCompletion}%
                                </span>
                              )}
                            </button>
                          </Link>

                          <Link to="/additionalinfo">
                            <button className="prg-btn1">
                              <span>
                                {additionalCompletion === 100 ? (
                                  <img src={checkIcon} alt="Completed" />
                                ) : (
                                  <img src={todoIcon} alt="Incomplete" />
                                )}
                              </span>
                              Additional Info
                              {additionalInfoLoading ? (
                                <span style={{ marginLeft: 8, fontSize: 14, color: '#999' }}>...</span>
                              ) : (
                                <span style={{ marginLeft: 8, fontSize: 14, color: '#666' }}>
                                  {additionalCompletion}%
                                </span>
                              )}
                            </button>
                          </Link>
                        </div>

                      </div>






                    </div>
                    <div className="col-6 prg-col1">
                      <h3>Latest Case Updates</h3>
                      <div className="prg-case">
                        <div className="updates-list">
                          {caseUpdatesLoading ? (
                            <p>Loading case updates...</p>
                          ) : caseUpdatesError ? (
                            <p className="error-message">{caseUpdatesError}</p>
                          ) : caseUpdates.length === 0 ? (
                            <p>No case updates found.</p>
                          ) : (
                            caseUpdates.map((update) => (
                              <div className="update-item" key={update.id}>
                                <div className="upd-date">
                                  {new Date(update.date).getDate()} <span>{new Date(update.date).toLocaleString('default', { month: 'short' })}</span>
                                </div>
                                <div className="upd-contn">
                                  <h4>{update.title}</h4>

                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          update.summary && update.summary.length > 90
                                            ? `${update.summary.slice(0, 90)}...`
                                            : update.summary || "",
                                      }}
                                    ></p>

                                </div>
                              </div>
                            ))
                          )}
                        </div>
                        <Link to="/caseUpdate">
                          <button className="view-btn">View all updates →</button>
                        </Link>
                      </div>

                      {/* <div className="prg-col1-list">
                        <h1> ✅ EOI Submitted </h1>
                        <p>Your registration has been received. You’re now part of the pricing class action investigation.  </p>
                        {profile?.user_status?.evidence && (
                          <>
                            {profile?.user_status?.evidence_status === 'Pending' && (
                              <>
                                <h1>⏳ Evidence Submitted</h1>
                                <p>Thanks! We’ve received your supporting documents. Our team will review them shortly.</p>
                              </>
                            )}

                            {profile?.user_status?.evidence_status === 'Accepted' && (
                              <>
                                <h1>⏳ Verification in Progress</h1>
                                <p>Your documents are being assessed for completeness and eligibility. No action needed right now.</p>
                              </>
                            )}

                            {profile?.user_status?.evidence_status === 'Rejected' && (
                              <>
                                <h1>❌ Further Information Required</h1>
                                <p>We need some additional details from you. Please check your inbox or dashboard to complete your submission.</p>
                              </>
                            )}
                          </>
                        )}







                        {profile?.legalfiling ? (
                          <>
                            <h1>⏳ Preparation for Legal Filing  </h1>
                            <p>Your details have been reviewed and are queued for inclusion in the legal filing.</p>
                          </>
                        ) : null}

                        {profile?.legalaction ? (
                          <>
                            <h1> 🔒 Awaiting Legal Action Launch  </h1>
                            <p>We’re preparing the formal submission. You’ll receive an update once proceedings are filed.</p>
                          </>
                        ) : null}

                        {profile?.user_status?.notify_status && (
                          <>
                            <h1>📬 Notifications & Updates</h1>
                            <p>Important updates will appear here and in your email. Be sure your contact info stays up to date.</p>
                          </>
                        )}
                      </div> */}

                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 prg-col1">
                      <div dangerouslySetInnerHTML={{ __html: dynamicContent?.dashboardcontent3 }} />
                      <div className="prg-col2">
                        <div className="prg-row3">
                          {notificationsLoading ? (
                            <p>Loading notifications...</p>
                          ) : notifications.length > 0 ? (
                            notifications.slice(0, 2).map(notification => {
                              let notifyClass = '';
                              if (notification.notifytype === 'success') {
                                notifyClass = 'successclass';
                              } else if (notification.notifytype === 'actionrequired') {
                                notifyClass = 'actionrequiredclass';
                              } else if (notification.notifytype === 'information') {
                                notifyClass = 'informationclass';
                              }

                              return (
                                <div
                                  className={`notfy-list ${notifyClass}`}
                                  key={notification.id}
                                >
                                  <div className="nty-head">
                                    <h4>
                                      {notification.notifytype} • {notification.created_date}
                                    </h4>
                                  </div>

                                  <div className="ntfy-cnt">
                                    <p>
                                      {notification.description.length > 200
                                        ? `${notification.description.substring(0, 200)}...`
                                        : notification.description}
                                    </p>
                                    {notification.description.length > 200 && (
                                      <Link to="/notifications">
                                        <button className="ntfy-btn1">Read more</button>
                                      </Link>
                                    )}


                                    {notification.actiontext && notification.pagelink && (
                                      <a
                                        href={notification.pagelink}
                                        onClick={e => {
                                          e.preventDefault();

                                          let path = notification.pagelink;

                                          // Ensure path starts with a slash for absolute path navigation
                                          if (!path.startsWith('/')) {
                                            path = '/' + path;
                                          }

                                          // Navigate to absolute path, ignoring current base (like /dashboard)
                                          navigate(path, { replace: false });
                                        }}
                                        className="ntfy-btn-action"
                                      >
                                        {notification.actiontext} →
                                      </a>


                                    )}
                                  </div>

                                </div>
                              );
                            })
                          ) : (
                            <p>No notifications found</p>
                          )}
                        </div>



                        {/* Show 'View more' button only if there are 5 or more notifications */}
                        {!notificationsLoading && notifications.length >= 2 && (
                          <Link to="/notifications">
                            <button className="evdn-btn1">View more →</button>
                          </Link>
                        )}

                      </div>
                    </div>
                    <div className="col-12 prg-col1">
                      <div dangerouslySetInnerHTML={{ __html: dynamicContent?.dashboardcontent2 }} />
                      <UploadFileWidget />

                        {evidenceList && evidenceList.length > 0 ? (

                          <div className="prg-col2">
                            <div className="prg-row1">
                              <div className="evdn-item">
                                <div className="evdn-col1">
                                  File Name
                                </div>
                                <div className="evdn-col2">
                                  Status
                                </div>
                              </div>

                              {loading ? (
                                <p>Loading evidence...</p>
                              ) : error ? (
                                <p className="error-message">{error}</p>
                              ) : (
                                evidenceList.slice(0, 2).map(evidence => (
                                  <div className="evdn-item" key={evidence.id}>
                                    <div className="evdn-col1">
                                      <h3>{evidence.image_name}</h3>
                                    </div>
                                    <div className="evdn-col2" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      {statusDisplay[evidence.status.toLowerCase()] || statusDisplay.pending}

                                      {/* Download icon */}
                                      <img
                                        src={downloadIcon} // make sure to import this image at component top
                                        alt="Download"
                                        className="download-btn"
                                        title="Download file"
                                        style={{ cursor: 'pointer', width: '40px', height: '35px' }}
                                        onClick={() => handleDownload(evidence)}
                                      />
                                    </div>
                                  </div>
                                ))
                              )}

                              {evidenceList.length >= 1 && (
                                <Link to="/evidence" className="evdn-btn1">View more →</Link>
                              )}

                            </div>

                          </div>

                        ):(

                            <p>No Files Uploaded </p>
                            
                        ) }


                    </div>
                  </div>
                </div>
              </div>
              <UserFooter />
            </main>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirmDelete}
        message="Do you want to remove this notification?"
      />
    </div>
  )
}

export default DashboardNew
